// extracted by mini-css-extract-plugin
module.exports = {"postContainer":"dashboard_postContainer__Mfr1y"};